export enum DocumentClass {
    ElectronicPolicy = 'PolizaElectronica',
    Preclaims = "Predenuncias",
    ProducerCommissionInvoice = "FacturaComisionesProductores",
    PaymentReceiptTransfer = "ReciboPagoTransferencia",
    RestockingOrder = "OrdenReposicion",
    PaymentReceiptTransferPreliq = "ReciboPagoTransferenciaPreliq",
    ElectronicCheck = "ChequeElectronico",
    WithholdingPreliquidation = "RetencionPreliquidacion",
    ObligatoryLifeInsured = "NominaVidaObligatorio",
}
